export const HOME_SHELL_EN = {
    'home.tabs': 'Home pages',
    'home.tab.default': 'Default',
    'home.tab.add': '+ Page',
    'home.tab.count': '{n} of {max}',
    'home.tab.menu': 'Options for «{page}»',
    'home.tab.rename': 'Rename',
    'home.tab.makeDefault': 'Make it first (the default)',
    'home.tab.earlier': 'Move left',
    'home.tab.later': 'Move right',
    'home.tab.remove': 'Remove the page',
    'home.tab.removed': '«{page}» was removed and kept in your archive.',
    'home.tab.restore': 'Restore',
    'home.page.new': 'New page',
    'home.page.lede': 'Your own page. Nobody else sees it.',
    'home.page.newCard': 'New card',
    'home.page.arrange': 'Arrange and resize',
    'home.rename.title': 'Rename the page',
    'home.rename.ar': 'Name in Arabic',
    'home.rename.en': 'Name in English',
    'home.copy.title': 'Copy the card to another page',
    'home.copy.to': 'Page',
    'home.copy.do': 'Copy',
    'home.copy.done': 'Copied to «{page}».',
    'home.save': 'Save',
    'home.cancel': 'Cancel',
    'home.stale': 'Your pages were changed somewhere else, so they were read again. What you just did was not saved; do it again if you still want it.',
    'home.saveFailed': 'The change was not saved: {reason}',
    'home.unreadable': 'Your pages could not be read right now, so only the default page is shown.',
    'home.figures': 'Figures from your modules',
    'home.figure.loading': 'Reading…',
    'home.figure.refused': 'Not open to you',
    'home.figure.failed': 'Could not be read now',
    'home.change.pages': 'Five pages is the most a home holds.',
    'home.change.cards': 'Twelve cards is the most a page holds.',
    'home.change.title': 'A page needs a name in both languages.',
    'home.change.hub': 'This page is drawn by the modules; it is changed from its own «Choose cards».',
    'home.change.last': 'The last page stays: a home needs one.',
    'home.change.missing': 'That page or card is no longer there.',
    'home.change.arranged': 'The cards changed while you arranged them. Try again.',
    'home.change.id': 'That page is already there.',
    'home.source.refused': 'not one of the read routes an enabled unit publishes',
    'home.studio.new': 'New card',
    'home.studio.edit': 'Edit: {title}',
    'home.studio.page': 'Page: {page}',
    'home.studio.lastEdit': 'Last changed {when}',
    'home.studio.previewNote': 'Preview with your data · read with your access',
    'home.studio.previewAfter': 'The preview after the change',
    'home.studio.previewEmpty': 'Say what you want to see, and the card appears here with your data.',
    'home.studio.proposing': 'The assistant is working on the card…',
    'home.studio.fact.source': 'Source',
    'home.studio.fact.filter': 'Filter',
    'home.studio.fact.refresh': 'Refresh',
    'home.studio.fact.noFilter': 'None',
    'home.studio.ok': 'Every field the card names is in the data.',
    'home.studio.missing': 'Not in the data: {fields}. A card is not added while it names a field that does not exist.',
    'home.studio.missingNear': '{field} (the data has {near})',
    'home.studio.unsaved': 'Not saved yet. The card on the page stays as it was until you press «Save the change».',
    'home.studio.add': 'Add to the page',
    'home.studio.save': 'Save the change',
    'home.studio.undo': 'Undo this session',
    'home.studio.cancel': 'Cancel',
    'home.studio.close': 'Close without saving',
    'home.studio.details': 'Details',
    'home.studio.detailsHide': 'Hide details',
    'home.studio.assistant': 'Assistant',
    'home.studio.thread': 'The conversation about this card',
    'home.studio.composerFirst': 'What do you want to see?',
    'home.studio.composerMore': 'Write what you want to change…',
    'home.studio.send': 'Send',
    'home.studio.privacy': 'Only what you write and the names of fields reach the assistant — never a value.',
    'home.studio.suggestions': 'Suggestions',
    'home.studio.sitting.created': '{date} · the card was made',
    'home.studio.sitting.edit': '{date} · an editing session',
    'home.studio.sitting.now': 'Now · this session',
    'home.studio.sitting.undone': '{sitting} · undone',
    'home.studio.gone': 'This card’s earlier conversation is no longer kept — conversations are kept for a limited time. I start from the card as it is.',
    'home.studio.none': 'This card has no earlier conversation. I start from the card as it is.',
    'home.studio.unreadable': 'The earlier conversation could not be read right now. I start from the card as it is.',
    'home.studio.loading': 'Reading this card’s conversation…',
    'home.studio.refused': 'Nothing changed: {reason}',
    'home.studio.undone': 'This session was undone; the card is as it was.',
    'home.studio.undoFailed': 'The card is as it was, but the conversation could not be marked: {reason}',
    'home.studio.noAssistant': 'The assistant is not available in this workspace right now. The card can still be changed by hand in «Details».',
    'home.studio.seconds': 'every {n} seconds',
    'home.studio.tone.neutral': 'Neutral',
    'home.studio.tone.blue': 'Blue',
    'home.studio.tone.green': 'Green',
    'home.studio.tone.amber': 'Amber',
    'home.studio.tone.red': 'Red',
    'home.studio.change.source': 'Source: {value}',
    'home.studio.change.shape': 'Shape: {value}',
    'home.studio.change.size': 'Size: {value}',
    'home.studio.change.title': 'Title: {value}',
    'home.studio.change.params': 'Parameters: {value}',
    'home.studio.change.params_removed': 'Parameters removed',
    'home.studio.change.filter_added': 'Filter: {value}',
    'home.studio.change.filter_removed': 'Filter removed: {value}',
    'home.studio.change.group': 'Grouped by {value}',
    'home.studio.change.measure': 'Measure: {value}',
    'home.studio.change.x': 'Over: {value}',
    'home.studio.change.column_added': 'New column: {value}',
    'home.studio.change.column_removed': 'Column removed: {value}',
    'home.studio.change.column_renamed': 'Column renamed: {value}',
    'home.studio.change.sort': 'Order: {value}',
    'home.studio.change.sort_removed': 'Order removed',
    'home.studio.change.limit': 'At most {value} shown',
    'home.studio.change.limit_removed': 'The usual number shown',
    'home.studio.change.refresh': 'Refresh: {value}',
    'home.studio.change.tone': 'Colour: {value}',
    'home.studio.change.corrected': 'Corrected before you saw it: {value}',
    'home.studio.change.ids_dropped': 'Id columns left out: {value}',
    'home.dialog.titleAr': 'Title in Arabic',
    'home.dialog.titleEn': 'Title in English',
    'home.dialog.source': 'Source',
    'home.dialog.filter': 'Filter',
    'home.dialog.noFilter': 'None',
    'home.dialog.dropCondition': 'Remove the condition {what}',
    'home.dialog.group': 'Group by',
    'home.dialog.over': 'Over',
    'home.dialog.columns': 'Columns',
    'home.dialog.measure': 'Measure',
    'home.dialog.shape': 'Shape',
    'home.dialog.size': 'Size',
    'home.dialog.refresh': 'Refresh',
    'home.dialog.sourceGone': 'Not in this workspace',
    'home.shape.number': 'Number',
    'home.shape.bars': 'Bars',
    'home.shape.table': 'Table',
    'home.shape.trend': 'Trend',
    'home.measure.count': 'Count',
    'home.measure.sum': 'Sum of {field}',
    'home.measure.avg': 'Average of {field}',
    'home.measure.min': 'Lowest {field}',
    'home.measure.max': 'Highest {field}',
    'home.refresh.60': 'Every minute',
    'home.refresh.300': 'Every 5 minutes',
    'home.refresh.900': 'Every 15 minutes',
    'home.refresh.3600': 'Every hour',
    // ── a card's forms: confirmed before anything is sent ──
    'home.form.confirm.title': 'Confirm before sending',
    'home.form.confirm.lede': 'This is sent in your name, with your own access. Nothing is sent until you confirm.',
    'home.form.confirm.action': 'Action',
    'home.form.confirm.where': 'To',
    'home.form.confirm.values': 'What is sent',
    'home.form.confirm.none': 'No values',
    'home.form.confirm.send': 'Send',
    'home.form.confirm.cancel': 'Don’t send',
    'home.form.notSent': 'Nothing was sent.',
    // ── what the studio says of a card's own markup ──
    'home.studio.empty': 'In the data, but empty in every row read: {fields}.',
    'home.studio.change.stripped': 'Removed {value}: {why}',
    'home.studio.change.style': 'Its own style (CSS)',
    'home.studio.change.style_removed': 'Its own style removed',
    'home.studio.change.template': 'Its own layout (HTML)',
    'home.studio.change.template_removed': 'Its own layout removed',
    'home.studio.change.script': 'Drawn by an isolated script: no network, and no reach into your session or the page',
    'home.studio.change.script_removed': 'The script removed',
    'home.studio.change.sources': 'Further reads for the script: {value}',
    'home.studio.change.form_added': 'Form: {value}',
    'home.studio.change.form_removed': 'Form removed: {value}',
    'home.stripped.unreadable': 'it could not be read whole',
    'home.stripped.at_rule': 'at-rules such as @import and @media are not allowed',
    'home.stripped.selector': 'a selector may name only the template’s tags and classes',
    'home.stripped.property': 'that property is not allowed',
    'home.stripped.value': 'that value is not allowed there',
    'home.stripped.url': 'nothing may link out or fetch anything',
    'home.stripped.bounds': 'the value is outside the allowed bounds',
    'home.stripped.position': 'a fixed, absolute or sticky position leaves the card',
    'home.stripped.important': '!important is not allowed',
    'home.stripped.tag': 'that tag is not allowed',
    'home.stripped.attribute': 'only class, dir, colspan and rowspan are allowed',
    'home.stripped.interpolation': 'that value cannot be named there',
    'home.stripped.nesting': 'it is nested deeper than allowed',
    'home.stripped.too_big': 'it is larger than allowed',
    'home.stripped.script_tag': 'a script may not hold a script tag or an HTML comment',
    'home.stripped.target': 'it is not a declared action a card may use',
    'home.stripped.source': 'it is not a read route you were offered, or no script reads it',
    'home.stripped.duplicate': 'it is repeated',
};
export const HOME_SHELL_AR = {
    'home.tabs': 'صفحات الرئيسية',
    'home.tab.default': 'افتراضية',
    'home.tab.add': '+ صفحة',
    'home.tab.count': '{n} من {max}',
    'home.tab.menu': 'خيارات «{page}»',
    'home.tab.rename': 'إعادة تسمية',
    'home.tab.makeDefault': 'اجعلها الأولى (الافتراضية)',
    'home.tab.earlier': 'تحريك لليمين',
    'home.tab.later': 'تحريك لليسار',
    'home.tab.remove': 'إزالة الصفحة',
    'home.tab.removed': 'أُزيلت «{page}» وحُفظت في أرشيفك.',
    'home.tab.restore': 'استعادة',
    'home.page.new': 'صفحة جديدة',
    'home.page.lede': 'صفحتك أنت. لا يراها غيرك.',
    'home.page.newCard': 'بطاقة جديدة',
    'home.page.arrange': 'ترتيب وحجم',
    'home.rename.title': 'إعادة تسمية الصفحة',
    'home.rename.ar': 'الاسم بالعربية',
    'home.rename.en': 'الاسم بالإنجليزية',
    'home.copy.title': 'نسخ البطاقة إلى صفحة أخرى',
    'home.copy.to': 'الصفحة',
    'home.copy.do': 'انسخ',
    'home.copy.done': 'نُسخت إلى «{page}».',
    'home.save': 'حفظ',
    'home.cancel': 'إلغاء',
    'home.stale': 'تغيّرت صفحاتك من مكان آخر، فأعدنا قراءتها. ما فعلته الآن لم يُحفظ؛ أعده إن كنت ما زلت تريده.',
    'home.saveFailed': 'لم يُحفظ التغيير: {reason}',
    'home.unreadable': 'تعذّرت قراءة صفحاتك الآن، فتظهر الصفحة الافتراضية وحدها.',
    'home.figures': 'أرقام من وحداتك',
    'home.figure.loading': 'جارٍ القراءة…',
    'home.figure.refused': 'غير متاح لك',
    'home.figure.failed': 'تعذّرت قراءته الآن',
    'home.change.pages': 'خمس صفحات هي أقصى ما تتسع له الرئيسية.',
    'home.change.cards': 'اثنتا عشرة بطاقة هي أقصى ما تتسع له الصفحة.',
    'home.change.title': 'تحتاج الصفحة إلى اسم باللغتين.',
    'home.change.hub': 'هذه الصفحة ترسمها الوحدات، وتُغيَّر من «تخصيص البطاقات» فيها.',
    'home.change.last': 'تبقى الصفحة الأخيرة: لا بد للرئيسية من صفحة.',
    'home.change.missing': 'لم تعد تلك الصفحة أو البطاقة موجودة.',
    'home.change.arranged': 'تغيّرت البطاقات أثناء ترتيبها. أعد المحاولة.',
    'home.change.id': 'هذه الصفحة موجودة بالفعل.',
    'home.source.refused': 'ليس من مسارات القراءة التي تعلنها وحدة مفعّلة',
    'home.studio.new': 'بطاقة جديدة',
    'home.studio.edit': 'تعديل: {title}',
    'home.studio.page': 'صفحة: {page}',
    'home.studio.lastEdit': 'آخر تعديل {when}',
    'home.studio.previewNote': 'معاينة ببياناتك · تُقرأ بصلاحياتك',
    'home.studio.previewAfter': 'المعاينة بعد التعديل',
    'home.studio.previewEmpty': 'اكتب ما تريد أن تراه، فتظهر البطاقة هنا ببياناتك.',
    'home.studio.proposing': 'يعمل المساعد على البطاقة…',
    'home.studio.fact.source': 'المصدر',
    'home.studio.fact.filter': 'التصفية',
    'home.studio.fact.refresh': 'التحديث',
    'home.studio.fact.noFilter': 'بلا تصفية',
    'home.studio.ok': 'كل الحقول التي تسمّيها البطاقة موجودة في البيانات.',
    'home.studio.missing': 'غير موجود في البيانات: {fields}. لا تُضاف البطاقة وفيها حقل غير موجود.',
    'home.studio.missingNear': '{field} (في البيانات: {near})',
    'home.studio.unsaved': 'لم يُحفظ بعد. البطاقة على الصفحة كما هي حتى تضغط «حفظ التعديل».',
    'home.studio.add': 'أضف إلى الصفحة',
    'home.studio.save': 'حفظ التعديل',
    'home.studio.undo': 'تراجع عن هذه الجلسة',
    'home.studio.cancel': 'إلغاء',
    'home.studio.close': 'إغلاق دون حفظ',
    'home.studio.details': 'تفاصيل',
    'home.studio.detailsHide': 'إخفاء التفاصيل',
    'home.studio.assistant': 'المساعد',
    'home.studio.thread': 'المحادثة حول هذه البطاقة',
    'home.studio.composerFirst': 'ماذا تريد أن ترى؟',
    'home.studio.composerMore': 'اكتب ما تريد تغييره…',
    'home.studio.send': 'إرسال',
    'home.studio.privacy': 'لا يصل إلى المساعد إلا ما تكتبه وأسماء الحقول، ولا تصل أي قيمة.',
    'home.studio.suggestions': 'اقتراحات',
    'home.studio.sitting.created': '{date} · أُنشئت البطاقة',
    'home.studio.sitting.edit': '{date} · جلسة تعديل',
    'home.studio.sitting.now': 'الآن · هذه الجلسة',
    'home.studio.sitting.undone': '{sitting} · تُراجع عنها',
    'home.studio.gone': 'لم تعد المحادثة السابقة لهذه البطاقة محفوظة، فالمحادثات تُحفظ مدة محدودة. أبدأ من البطاقة كما هي.',
    'home.studio.none': 'لا محادثة سابقة لهذه البطاقة. أبدأ من البطاقة كما هي.',
    'home.studio.unreadable': 'تعذّرت قراءة المحادثة السابقة الآن. أبدأ من البطاقة كما هي.',
    'home.studio.loading': 'تُقرأ محادثة هذه البطاقة…',
    'home.studio.refused': 'لم يتغيّر شيء: {reason}',
    'home.studio.undone': 'تراجعتَ عن هذه الجلسة؛ البطاقة كما كانت.',
    'home.studio.undoFailed': 'البطاقة كما كانت، لكن تعذّر تعليم المحادثة: {reason}',
    'home.studio.noAssistant': 'المساعد غير متاح في هذه المساحة الآن. يمكن تعديل البطاقة يدوياً من «تفاصيل».',
    'home.studio.seconds': 'كل {n} ثانية',
    'home.studio.tone.neutral': 'محايد',
    'home.studio.tone.blue': 'أزرق',
    'home.studio.tone.green': 'أخضر',
    'home.studio.tone.amber': 'كهرماني',
    'home.studio.tone.red': 'أحمر',
    'home.studio.change.source': 'المصدر: {value}',
    'home.studio.change.shape': 'الشكل: {value}',
    'home.studio.change.size': 'الحجم: {value}',
    'home.studio.change.title': 'العنوان: {value}',
    'home.studio.change.params': 'المعاملات: {value}',
    'home.studio.change.params_removed': 'أُزيلت المعاملات',
    'home.studio.change.filter_added': 'تصفية: {value}',
    'home.studio.change.filter_removed': 'أُزيلت التصفية: {value}',
    'home.studio.change.group': 'التجميع: حسب {value}',
    'home.studio.change.measure': 'القياس: {value}',
    'home.studio.change.x': 'على امتداد: {value}',
    'home.studio.change.column_added': 'عمود جديد: {value}',
    'home.studio.change.column_removed': 'أُزيل عمود: {value}',
    'home.studio.change.column_renamed': 'اسم عمود جديد: {value}',
    'home.studio.change.sort': 'الترتيب: {value}',
    'home.studio.change.sort_removed': 'أُزيل الترتيب',
    'home.studio.change.limit': 'يُعرض {value} على الأكثر',
    'home.studio.change.limit_removed': 'العدد المعتاد لما يُعرض',
    'home.studio.change.refresh': 'التحديث: {value}',
    'home.studio.change.tone': 'اللون: {value}',
    'home.studio.change.corrected': 'تصحيح تلقائي قبل أن تراه: {value}',
    'home.studio.change.ids_dropped': 'أُخرجت أعمدة المعرّفات: {value}',
    'home.dialog.titleAr': 'العنوان بالعربية',
    'home.dialog.titleEn': 'العنوان بالإنجليزية',
    'home.dialog.source': 'المصدر',
    'home.dialog.filter': 'تصفية',
    'home.dialog.noFilter': 'بلا تصفية',
    'home.dialog.dropCondition': 'أزل الشرط {what}',
    'home.dialog.group': 'تجميع حسب',
    'home.dialog.over': 'على امتداد',
    'home.dialog.columns': 'الأعمدة',
    'home.dialog.measure': 'القياس',
    'home.dialog.shape': 'الشكل',
    'home.dialog.size': 'الحجم',
    'home.dialog.refresh': 'التحديث',
    'home.dialog.sourceGone': 'ليس في هذه المساحة',
    'home.shape.number': 'رقم',
    'home.shape.bars': 'أعمدة',
    'home.shape.table': 'جدول',
    'home.shape.trend': 'اتجاه',
    'home.measure.count': 'العدد',
    'home.measure.sum': 'مجموع {field}',
    'home.measure.avg': 'متوسط {field}',
    'home.measure.min': 'أدنى {field}',
    'home.measure.max': 'أعلى {field}',
    'home.refresh.60': 'كل دقيقة',
    'home.refresh.300': 'كل 5 دقائق',
    'home.refresh.900': 'كل 15 دقيقة',
    'home.refresh.3600': 'كل ساعة',
    // ── نماذج البطاقة: تأكيد قبل أي إرسال ──
    'home.form.confirm.title': 'تأكيد قبل الإرسال',
    'home.form.confirm.lede': 'يُرسل هذا باسمك وبصلاحياتك أنت، ولا يُرسل شيء قبل أن تؤكد.',
    'home.form.confirm.action': 'الإجراء',
    'home.form.confirm.where': 'إلى',
    'home.form.confirm.values': 'ما سيُرسل',
    'home.form.confirm.none': 'لا قيم',
    'home.form.confirm.send': 'أرسل',
    'home.form.confirm.cancel': 'لا ترسل',
    'home.form.notSent': 'لم يُرسل شيء.',
    // ── ما يقوله الاستوديو عن تنسيق البطاقة الخاص ──
    'home.studio.empty': 'موجود في البيانات لكنه فارغ في كل الصفوف المقروءة: {fields}.',
    'home.studio.change.stripped': 'حُذف {value} لأن {why}',
    'home.studio.change.style': 'تنسيق خاص (CSS)',
    'home.studio.change.style_removed': 'أُزيل التنسيق الخاص',
    'home.studio.change.template': 'قالب خاص (HTML)',
    'home.studio.change.template_removed': 'أُزيل القالب الخاص',
    'home.studio.change.script': 'يرسمها سكربت معزول: بلا شبكة، ولا يصل إلى جلستك ولا إلى الصفحة',
    'home.studio.change.script_removed': 'أُزيل السكربت',
    'home.studio.change.sources': 'قراءات إضافية للسكربت: {value}',
    'home.studio.change.form_added': 'نموذج: {value}',
    'home.studio.change.form_removed': 'أُزيل النموذج: {value}',
    'home.stripped.unreadable': 'تعذّرت قراءته كاملاً',
    'home.stripped.at_rule': 'قواعد @ مثل ‎@import و‎@media غير مسموحة',
    'home.stripped.selector': 'المحدِّد لا يسمّي إلا وسوم القالب وأصنافه',
    'home.stripped.property': 'هذه الخاصية غير مسموحة',
    'home.stripped.value': 'هذه القيمة غير مسموحة هنا',
    'home.stripped.url': 'لا يُسمح بأي رابط أو تحميل من الخارج',
    'home.stripped.bounds': 'القيمة خارج الحدود المسموحة',
    'home.stripped.position': 'الموضع الثابت أو المطلق أو اللاصق يخرج عن البطاقة',
    'home.stripped.important': '‎!important غير مسموحة',
    'home.stripped.tag': 'هذا الوسم غير مسموح',
    'home.stripped.attribute': 'المسموح من السمات class وdir وcolspan وrowspan فقط',
    'home.stripped.interpolation': 'هذه القيمة لا تُسمّى هنا',
    'home.stripped.nesting': 'تداخله أعمق من المسموح',
    'home.stripped.too_big': 'حجمه أكبر من المسموح',
    'home.stripped.script_tag': 'لا يحوي السكربت وسم script ولا تعليق HTML',
    'home.stripped.target': 'ليس إجراءً معلناً تستعمله البطاقة',
    'home.stripped.source': 'ليس مسار قراءة معروضاً لك، أو لا سكربت يقرؤه',
    'home.stripped.duplicate': 'مكرر',
};
//# sourceMappingURL=i18n-home-shell.js.map